import { ButtonFilled } from '@vgw/multibrand-fe-button'
import { accept, block } from '@vgw/mar-cookie-consent'
import { Trans } from '@lingui/react/macro'
import { useCookieConsentBannerStore } from './cookie-consent-banner-store'
import { getBrandConfig } from '@/config/config'

const brandConfig = getBrandConfig()

export const CookieConsentBanner = () => {
  const setIsCookiesBannerVisible = useCookieConsentBannerStore(
    (state) => state.setIsCookiesBannerVisible,
  )

  const onAcceptAll = () => {
    setIsCookiesBannerVisible(false)
    accept()
  }
  const onBlockAll = () => {
    setIsCookiesBannerVisible(false)
    block()
  }

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-description"
      data-testid="cookie-consent-banner"
      className="fixed right-3 bottom-6 left-3 z-50 max-w-91.5 space-y-4 rounded-md bg-surface-secondary px-3 py-6 shadow-drop sm:left-6"
    >
      <div className="pl-2 text-sm xl:text-base" id="cookie-banner-description">
        <p className="inline text-content">
          <Trans>
            We use cookies and similar technologies to enhance your experience,
            analyze traffic, personalize content, including targeted ads and
            behavioral profiling. By clicking &quot;Accept All&quot; or
            continuing to use our site, you consent to the use of all cookies
            and the sharing of information they collect with third parties.{' '}
            <a href={brandConfig.cookieNoticeLink} className="underline">
              Cookie Notice
            </a>
            . To stop the sharing of your personal information, click
            &quot;Reject All&quot;. To control your preferences, please click
            the &quot;Do Not Sell or Share My Personal Information&quot; link in
            the footer.
          </Trans>
        </p>
      </div>
      <div className="flex items-center gap-2 pl-2">
        <ButtonFilled className="flex-1" onClick={onAcceptAll}>
          <Trans>Accept All</Trans>
        </ButtonFilled>
        <ButtonFilled className="flex-1" onClick={onBlockAll}>
          <Trans>Reject All</Trans>
        </ButtonFilled>
      </div>
    </div>
  )
}
